/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from "jquery";
import prestashop from "prestashop";
import ListingDisplay from "./components/ListingDisplay";
$(() => {
  const parseSearchUrl = function(event) {
    if (event.target.dataset.searchUrl !== void 0) {
      return event.target.dataset.searchUrl;
    }
    if ($(event.target).parent()[0].dataset.searchUrl === void 0) {
      throw new Error("Can not parse search URL");
    }
    return $(event.target).parent()[0].dataset.searchUrl;
  };
  $("body").on("change", "#search_filters input[data-search-url]", function(event) {
    prestashop.emit("updateFacets", parseSearchUrl(event));
  });
  $("body").on("click", ".js-search-filters-clear-all", function(event) {
    prestashop.emit("updateFacets", parseSearchUrl(event));
  });
  $("body").on("click", ".js-search-link", function(event) {
    event.preventDefault();
    prestashop.emit("updateFacets", $(event.target).closest("a").get(0).href);
  });
  $("body").on("change", "#select-sort-order", function() {
    var urlsearch = $(this).val();
    prestashop.emit("updateFacets", urlsearch);
  });
  $("body").on("change", "#search_filters select", function(event) {
    var urlsearch = $(this).val();
    prestashop.emit("updateFacets", urlsearch);
  });
  prestashop.on("updateProductList", (data) => {
    updateProductListDOM(data);
    window.scrollTo(0, 0);
  });
});
function updateProductListDOM(data) {
  $("#search_filters").replaceWith(data.rendered_facets);
  $("#js-active-search-filters").replaceWith(data.rendered_active_filters);
  $("#js-product-list-top").replaceWith(data.rendered_products_top);
  $("#js-product-list").replaceWith(data.rendered_products);
  $("#js-product-list-bottom").replaceWith(data.rendered_products_bottom);
  if (typeof data.rendered_products_header !== "undefined" && data.rendered_products_header) {
    $("#js-product-list-header").replaceWith(data.rendered_products_header);
  }
  prestashop.emit("updatedProductList", data);
}
if (module.hot) { module.hot.accept(); }